export function isBoolean(o?: any): o is boolean {
    return typeof o === 'boolean';
}